import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Button, Dialog, DialogContent, IconButton, DialogTitle, Divider, Grid, List, ListItemButton, MenuItem, Paper, Select, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, Typography, Autocomplete, TextField, FormControl, ListItem, ListItemText, DialogActions, Checkbox, Box, Switch, Menu, InputAdornment } from "@mui/material";
import React, { Fragment, useEffect, useMemo, useState, useRef } from "react";
import close from "../../asset/image/close.svg";
import _, { template } from "lodash";

import { Info } from "@material-ui/icons";
import moment from "moment";
import { getDataFromLocalStorage } from "../../utils/util";
import { USER_OU } from "../../constants/Constants";
import { assignCustomPlanAPI, getServiceLinePerPlan, getServiceLinePerPlanRight, moveServicePlanAPI, showToastMessage, trackMoveServicePlan, clearTrackAPI, clearMoveServicePlan } from "../StarlinkPooled/slice";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import customPlanIcon from "../../asset/image/CustomPlanIcon.svg";
import starlinkPlanIcon from "../../asset/image/StarlinkPlanIcon.svg";
import planFilterButton from "../../asset/image/planFilterButton.svg";
import planHierarchyImg from "../../asset/image/planHierarchyImg.svg";
import orgPoolIcon from "../../asset/image/OrgPoolIcon.svg";
import { Edit, AddCircle } from "@material-ui/icons";
import TuneIcon from "@mui/icons-material/Tune";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import authReducer from "../../reducers/authReducer";
import DataBlockCounter from "../StarlinkAdmin/ServiceLines/DataBlockCounter";
import CommonModal from "../../UserScreen/InventoryPage/InventorySettings/components/Modals/CommonModal";
import AddEditInterfaceModal from "../../UserScreen/InventoryPage/InventorySettings/components//Modals/AddEditInterfaceModal";
import { toast } from "react-toastify";

var Loader = require("react-loader");
type DataBlockState = { [productId: string]: number; };

const AssignServiceLine = (props) => {
    const { open, setOpen, loading, planData, getServiceLinePerPlan, authReducer, slClicked, setSlClicked, callStarlinkTemplateAPI, trackServicePlanMovement, serviceLinePlans, clearMoveServicePlan, getServiceLinePerPlanRight, callPlanHierarchyAPI, serviceLinePlansRight, moveServicePlanAPI, trackMoveServicePlan, clearTrackAPI, moveServicePlan } = props;
    const searchTimeoutRef = useRef<any>();
    const [expandedRows, setExpandedRows] = useState({});
    const [searchValue, setSearchValue] = useState("");
    const [searchValuePlanHierarchy, setSearchValuePlanHierarchy] = useState("");
    const [searchValueRight, setSearchValueRight] = useState("");
    const [selectedPlan, setSelectedPlan] = useState<any>(null);
    const [selectedPlanRight, setSelectedPlanRight] = useState<any>(null);
    const [highlightedRows, setHighlightedRows] = useState<any>([]);
    const [highlightedRowsRight, setHighlightedRowsRight] = useState<any>([]);
    const [options, setOptions] = useState<any>([]);
    const ENTER_KEY_CODE = 'Enter';
    const [moveClickedToRight, setMoveClickedToRight] = useState(false)
    const [moveClickedToMiddle, setMoveClickedToMiddle] = useState(false)
    const [servicePlansLocal, setServicePlansLocal] = useState<any>([])
    const [servicePlansRightLocal, setServicePlansRightLocal] = useState<any>([])
    const [confirmDialog, setConfirmDialog] = useState<boolean>(false)
    const [selectedBox, setSelectedBox] = useState<any>("")
    const [selectedServiceLines, setSelectedServiceLines] = useState<any>([]);
    const [customPlanId, setCustomPlanId] = useState<any>(null);
    const [customPlanIdRight, setCustomPlanIdRight] = useState<any>(null);
    const [accountNumber, setAccountNumber] = useState(null)
    const [accountNumberRight, setAccountNumberRight] = useState(null)
    const [hoveredSL, setHoveredSL] = useState(null)
    const [switchServiceLineToggle, setSwitchServiceLineToggle] = useState(false)
    const [screenLoader, setScreenLoader] = useState({loading: false, message1: '', message2: ''})
    const [dataBlockAll, setDataBlockAll] = useState<DataBlockState>({})

    const MIDDLE = "middle"

    useEffect(()=>{
          setSelectedBox(MIDDLE)
        if(open ){
          trackMoveServicePlan({
                dp_id: authReducer?.selectedOu?.id,
                tracking_id: localStorage?.getItem("BULK_ASSIGNMENT_TRACKING_ID") ? localStorage?.getItem("BULK_ASSIGNMENT_TRACKING_ID") : ""
            });}
    },[open])
   
    useEffect(() => {
        if (slClicked) {
              setSelectedBox(MIDDLE)
            handleRowClick(slClicked, MIDDLE)
        }
    }, [slClicked])

    const clearData = () =>{
        
        setHighlightedRows([])
        setHighlightedRowsRight([])
        setMoveClickedToRight(false)
        setMoveClickedToMiddle(false)
        if(!localStorage?.getItem("BULK_ASSIGNMENT_TRACKING_ID")){
        setSelectedPlan(null)
        setSelectedPlanRight(null)
        setServicePlansLocal([])
        setServicePlansRightLocal([])
        }
        setSelectedBox("")
        setSlClicked(null)
    }

     const handleReset = () =>{
        setServicePlansLocal(serviceLinePlans)
        setServicePlansRightLocal(serviceLinePlansRight)
        setHighlightedRows([])
        setHighlightedRowsRight([])
    }

    useEffect(() => {
        if (!_.isEmpty(serviceLinePlans)) {
            setServicePlansLocal(serviceLinePlans)
        } else {
            setServicePlansLocal([])
        }
    }, [serviceLinePlans])

    useEffect(() => {
        if (!_.isEmpty(serviceLinePlansRight)) {
            setServicePlansRightLocal(serviceLinePlansRight)
        } else {
            setServicePlansRightLocal([])
        }
    }, [serviceLinePlansRight])

    const handleExpandClick = (id) => {
        setExpandedRows((prev) => ({
            ...prev,
            [id]: !prev[id],
        }));
    };

    const findParentPath = (data, targetUid) => {
        let path = [];

        const traverse = (items, currentPath = []) => {
            for (let item of items) {
                let newPath: any = [...currentPath, item.uid];

                if (item.uid === targetUid) {
                    path = newPath;
                    return;
                }

                if (item.children?.length > 0) {
                    traverse(item.children, newPath);
                }
            }
        };

        traverse(data);
        return path;
    };


    const handleExpandClickForPath = (uids) => {
        setExpandedRows((prev) => {
            let newExpandedRows = { ...prev };
            uids.forEach(uid => {
                newExpandedRows[uid] = true; // Expand each row in the path
            });
            return newExpandedRows;
        });
    };


    const expandRowsAboveUid = (uid) => {
        const parentPath = findParentPath(planData, uid);
        handleExpandClickForPath(parentPath);
    };

    const [hoveredRow, setHoveredRow] = useState(null)

    const getBorderStyle = (row) => {
        if (hoveredRow === row?.uid && selectedBox !== "") {
            return selectedBox === MIDDLE
                ? "2px solid #53E1AE"
                : selectedBox === "right"
                    ? "2px solid #8CC5F6"
                    : "";
        }
        return "";
    };

    const getBorderStyles = (row) => {
        if (hoveredSL === row?.id && selectedBox !== "") {
            return "2px solid #53E1AE";
        }
        return "";
    };

    const handleRowClick = (row, selectedBox) => {

        if( highlightedRowsRight?.length > 0){
             toast.error("Pending Changes. Please commit or cancel your changes before loading a new plan.", {
                    position: toast.POSITION.BOTTOM_LEFT,
                  });
            return
        }
        // setSelectedRow(row?.uid);
        const selectedObj = options.find(option => option.value === row?.uid);

        if (selectedObj && selectedBox !== "") {
            if (selectedBox === MIDDLE) {
                setServicePlansRightLocal( Array.isArray(serviceLinePlansRight) ? [...serviceLinePlansRight] : []);
                 if(selectedPlanRight && selectedPlanRight?.value === selectedObj?.value){
                    return
                }
                setSelectedPlan(selectedObj)
                let params = {
                    dp_id: authReducer?.selectedOu?.id,
                    custom_plan_id: selectedObj?.icon === "starlinkPlanIcon" ? "" : selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
                    org_filter: "",
                    search: searchValue,
                    account_number: row?.account_number,
                    product_reference_id: selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
                    plan_type:  selectedObj?.icon === "starlinkPlanIcon" ? "standard" : "pooled",
                    
                }
                setCustomPlanId(selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "")
                setAccountNumber(row?.account_number)
                getServiceLinePerPlan(params)
                setHighlightedRows([])
                setHighlightedRowsRight([])
            } else {
                setServicePlansLocal( Array.isArray(serviceLinePlans) ? [...serviceLinePlans] : [])
                 if(selectedPlan && selectedPlan?.value === selectedObj?.value){
                    return
                }
                setSelectedPlanRight(selectedObj);
                let params = {
                    dp_id: authReducer?.selectedOu?.id,
                    custom_plan_id: selectedObj?.icon === "starlinkPlanIcon" ? "" : selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
                    org_filter: "",
                    search: searchValueRight,
                    account_number: row?.account_number,
                    product_reference_id: selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "",
                    plan_type:  selectedObj?.icon === "starlinkPlanIcon" ? "standard" : "pooled",
                }

                setCustomPlanIdRight(selectedObj?.type && selectedObj?.type === 'Main Pool' ? "" : selectedObj?.val ? selectedObj.val : "")
                setAccountNumberRight(row?.account_number)
                getServiceLinePerPlanRight(params)
               
                setHighlightedRows([])
                setHighlightedRowsRight([])
            }
        }

    };

    const getBackgroundColor = (rowVal) => {
        if (selectedPlan?.value === rowVal?.uid) {
            return "#53E1AE";
        }

        if (selectedPlanRight?.value === rowVal?.uid) {
            return "#8CC5F6";
        }

    }

    const renderRow = (row, level = 0) => (
        <React.Fragment key={row.uid}>
            <TableRow className="strPlan-tableRow"
                onMouseEnter={() => { setHoveredRow(row.uid); }}
                onMouseLeave={() => setHoveredRow(null)} >
                <TableCell onClick={(event) => {  handleRowClick(row, selectedBox) }}
                    className={`starPlan-hierarchy-table-cell`}
                    style={{
                        padding: `10px 0px 10px ${level * 20}px`,
                        borderTop: getBorderStyle(row),
                        borderLeft: getBorderStyle(row),
                        borderBottom: getBorderStyle(row),
                        backgroundColor: getBackgroundColor(row)
                    }}

                >
                  {row.children?.length > 0 ? (
                    <IconButton
                        size="small"
                        className="strPlans-icon-padding"
                        onClick={(event) => {
                            event.stopPropagation();
                            handleExpandClick(row?.uid);
                        }}
                    >
                        {expandedRows[row.uid] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </IconButton>
                ) : (
                    <div style={{ width: 25, display: 'inline-block' }} /> 
                )}
                    <Grid className="strPlans-pln-hir-name"
                        style={{ paddingLeft: `${level * 15}px`, }}>
                        {row?.icon ? <img className="icon-cursor strPlans-pd-r-10" src={row?.icon === "CustomPlanIcon" ? customPlanIcon : row?.icon === "orgPoolIcon" ? orgPoolIcon : starlinkPlanIcon} /> : null}
                        {row?.account_type ? row?.account_type.charAt(0).toUpperCase() + row?.account_type.slice(1).toLowerCase() + " | " : ""}
                        <Tooltip
                            title={row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || ""}
                            placement="top"
                            arrow
                        ><span>
                                {(row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || '').slice(0, 25) + ((row?.account_name || row?.custom_plan_name || row?.pool_name || row?.plan_name || '').length > 25 ? "..." : "")}
                            </span></Tooltip>
                    </Grid>
                </TableCell>

                <TableCell align="center"
                    style={{
                        borderTop: getBorderStyle(row),
                        borderBottom: getBorderStyle(row),
                        backgroundColor: getBackgroundColor(row)
                    }}
                    className={(selectedPlan !== "" && selectedPlan?.value === row?.uid) ? "strPlan-color-blue strPlan-background-blue" : "strPlan-color-blue strPlan-background-transparent"}
                    onClick={() => handleRowClick(row, selectedBox)} >{row?.organizations ? row?.organizations?.length : 0}</TableCell>


                <TableCell align="center"
                    style={{
                        borderTop: getBorderStyle(row),
                        borderRight: getBorderStyle(row),
                        borderBottom: getBorderStyle(row),
                        backgroundColor: getBackgroundColor(row)
                    }}
                    className={(selectedPlan !== "" && selectedPlan?.value === row?.uid) ? "strPlan-color-blue strPlan-background-blue" : "strPlan-color-blue strPlan-background-transparent"}
                    onClick={() => handleRowClick(row, selectedBox)} >{ row?.total_service_lines || row?.direct_service_lines ? expandedRows[row.uid] ? row?.direct_service_lines : row.total_service_lines : row?.service_lines ? row?.service_lines : 0 }</TableCell>

            </TableRow>

            {expandedRows[row?.uid] && row.children?.length > 0 && (
                row.children.map((child) => renderRow(child, level + 1))
            )}
        </React.Fragment>
    );

    const handleRowSelection = (id) => {
        setSelectedServiceLines((prevSelected) =>
            prevSelected.includes(id)
                ? prevSelected.filter((rowId) => rowId !== id)
                : [...prevSelected, id]
        );
    };

    const isSelected = (id) => selectedServiceLines.includes(id);

    useEffect(() => {
        let params = {
            dp_id: authReducer?.selectedOu?.id,
            custom_plan_id: customPlanIdRight,
            org_filter: "",
            search: searchValueRight,
            account_number: accountNumberRight,
        }

        getServiceLinePerPlanRight(params)
    }, [searchValueRight])

    useEffect(() => {
        let params = {
            dp_id: authReducer?.selectedOu?.id,
            custom_plan_id: customPlanId,
            org_filter: "",
            search: searchValue,
            account_number: accountNumber,
            product_reference_id: selectedPlan?.type && selectedPlan?.type === 'Main Pool' ? "" : selectedPlan?.val ? selectedPlan.val : "",
            plan_type:  selectedPlan?.icon === "starlinkPlanIcon" ? "standard" : "pooled",
        }

        getServiceLinePerPlan(params)
    }, [searchValue])



    const extractPlanPoolOptions = (data, options: any = [], level = 0) => {
        data?.forEach((item: any) => {
            if (item.account_type !== 'standard' ){
                if (item.pool_name) {
                    options.push({ 
                        value: item.uid, 
                        val: item.custom_plan_id, 
                        label: item.pool_name, 
                        type: "Pool", level, 
                        icon: item?.icon,
                        account_number: item?.account_number,
                        sl: item.service_lines, 
                        size: item?.unit === "tb" ? item?.size*1000 : item?.size  });
                } else if (item.custom_plan_name || item.plan_name) {
                    options.push({
                        val: item.id,
                        value: item.uid,
                        label: item.custom_plan_name || item.plan_name,
                        account_number: item?.account_number,
                        data_block_product_details: item?.data_block_product_details || [],
                        price: item?.price,
                        type: "Plan",
                        level, icon: item?.icon,
                        sl: item.service_lines, 
                        size: item?.unit === "tb" ? item?.size*1000 : item?.size 
                    });
                } else if (item.account_name) {
                    options.push({ value: item.uid, val: item.uid, label: item.account_name, type: "Main Pool", level, icon: item?.icon, sl: item.service_lines, account_number: item?.account_number,
                        size: item?.unit === "tb" ? item?.size*1000 : item?.size  });
                }
            }
                if (item.children?.length) {
                    extractPlanPoolOptions(item.children, options, level + 1);
                }
            
        });

        return options;
    };


    // const extractPlanPoolOptions = (data, options: any = []) => {
    //     data?.forEach((item: any) => {
    //         if (item.account_type !== 'standard') {
    //             if (item.icon !== "starlinkPlanIcon") {
    //                 if (item.pool_name) {
    //                     options.push({ value: item.uid, val: item.custom_plan_id, label: item.pool_name, type: "Pool" });
    //                 } else if (item.custom_plan_name || item.plan_name) {
    //                     options.push({
    //                         val: item.id,
    //                         value: item.uid,
    //                         label: item.custom_plan_name || item.plan_name,
    //                         type: "Plan",
    //                     });
    //                 } else if (item.account_name) {
    //                     options.push({ value: item.uid, val: item.uid, label: item.account_name, type: "Main Pool" });
    //                 }

    //                 if (item.children?.length) {
    //                     extractPlanPoolOptions(item.children, options);
    //                 }
    //             }
    //         }
    //     });

    //     return options;
    // };

    useMemo(() => {
        if (!_.isEmpty(planData)) {
            setOptions(extractPlanPoolOptions(planData))
        }
    }, [planData]);



    const handleHighlightedRowClick = (row) => {
        setHighlightedRows((prevHighlighted) => {
            const exists = prevHighlighted.some((item) => item.id === row.id);
            return exists
                ? prevHighlighted.filter((item) => item.id !== row.id)
                : [...prevHighlighted, row];
        });
    };


    const isHighlighted = (id: string) => {
        return highlightedRows.some((item) => item.id === id);
    };

    const [highlightedRowsRightTransfer, setHighlightedRowsRightTransfer] = useState<any>([])

    const handleHighlightedRowsClick = (row: { id: number; account_number: string }) => {
        setHighlightedRowsRightTransfer([...highlightedRowsRightTransfer, row]);
        };

          const isHighlightTransfer = (id: number) => {
        return highlightedRowsRightTransfer.some((item) => item.id === id);
    };


    const isHighlight = (id: number) => {
        return highlightedRowsRight.some((item) => item.id === id);
    };

    const handleAssignPlanToLeft = () => {

        if (!_.isEmpty(highlightedRowsRight)) {
            let params = {
                organizationId: authReducer?.selectedOu?.id,
                serviceLines: highlightedRowsRight?.map((item) => item.id),
                customPlanId: selectedPlan?.val,
                allowDowngradeNow: false,
                accountNumber: highlightedRowsRight[0]?.accountNumber
            }

            moveServicePlanAPI(params)
        }
    }

    const [trackingId, setTrackingId] = useState(null);
    const pollerRef = useRef<any>(null);

    useEffect(() => {
        if (!trackingId) return;

        const poll = () => {
            trackMoveServicePlan({
                dp_id: authReducer?.selectedOu?.id,
                tracking_id: trackingId
            });
        };

        poll();
        pollerRef.current = setInterval(poll, 5000);

        return () => clearInterval(pollerRef.current);
    }, [trackingId]);

    useEffect(() => {
        if(!_.isEmpty(moveServicePlan)){
        const trackingId = moveServicePlan?.data?.trackingId;
        if (!trackingId) return

        setTrackingId(trackingId);
        localStorage?.setItem("BULK_ASSIGNMENT_TRACKING_ID", trackingId);
        clearMoveServicePlan()
    }
    }, [moveServicePlan])

    useEffect(() => {
        if(!_.isEmpty(trackServicePlanMovement) ){
        const info = trackServicePlanMovement?.[0];
        if (!info) return;

        const { status, success_count, total_service_lines, tracking_id } = info;

        const percent = total_service_lines
            ? Math.round((success_count / total_service_lines) * 100)
            : 0;


        if (status === "in_progress") {
            setScreenLoader({
                loading: true,
                message1: `Assignment in progress (${percent}%)`,
                message2: `${success_count} / ${total_service_lines} completed`
            });
            return;
        }

        if (status === "completed") {
            if(localStorage?.getItem("BULK_ASSIGNMENT_TRACKING_ID")){
            showToastMessage({ success: true, message: "Service Line Assignment Completed. Please refer to audit logs for more info." }, "");
            localStorage?.removeItem("BULK_ASSIGNMENT_TRACKING_ID");
            setTrackingId(null);
            }
            clearInterval(pollerRef.current);
            pollerRef.current = null;
            clearTrackAPI()
            setScreenLoader({ loading: false, message1: '', message2: '' });

            refreshTables();
        }
    }
    }, [trackServicePlanMovement]);

    const buildParams = (plan, search, account) => ({
        dp_id: authReducer?.selectedOu?.id,
        custom_plan_id: plan?.icon === "starlinkPlanIcon" ? "" : plan?.type && plan?.type === 'Main Pool' ? "" : plan?.val ? plan.val : "",
        product_reference_id: plan?.type === "Main Pool" ? "" : plan?.val || "",
        org_filter: "",
        search,
        account_number: account,
        plan_type: plan?.icon === "starlinkPlanIcon" ? "standard" : "pooled"
    });

    const refreshTables = () => {
        getServiceLinePerPlan(buildParams(selectedPlan, searchValue, accountNumber));
        getServiceLinePerPlanRight(buildParams(selectedPlanRight, searchValueRight, accountNumberRight));
    };


    const handleAssignPlanToRight = () => {
        const assignPlans = (rows, plan) => {
            let params;

            if ( selectedPlanRight?.icon === "starlinkPlanIcon") {
                const dataBlockProducts = Object.entries(dataBlockAll)
                .map(([productId, count]) => ({
                    productId,
                    count
                }))
                
                 params = {
                    organizationId: authReducer?.selectedOu?.id,
                    serviceLines: rows?.map(item => ({ serviceLineNumber: item.id, kitIds: item?.kitids, nickname: item?.service_lines })),
                    customPlanId: "" ,
                    allowDowngradeNow: false,
                    accountNumber: selectedPlanRight?.account_number,
                    productReferenceId: selectedPlanRight?.val,
                    dataBlockProducts: dataBlockProducts
                };
            }
            else {
                 params = {
                    organizationId: authReducer?.selectedOu?.id,
                    serviceLines: rows?.map(item => ({ serviceLineNumber: item.id, kitIds: item?.kitids, nickname: item?.service_lines })),
                    customPlanId: plan?.type === "Main Pool" ? "" : plan?.val,
                    allowDowngradeNow: false,
                    accountNumber: selectedPlanRight?.account_number,
                };
            }

            moveServicePlanAPI(params);
            setScreenLoader({
                loading: true,
                message1: "The assignment of service lines are currently in progress.",
                message2: "Multiple service lines are being processed. This step may take longer than usual depending on volume. Please check back after some time."
            });
            setHighlightedRows([]);
            setHighlightedRowsRight([]);
            setMoveClickedToRight(false);
            setConfirmDialog(false);
            setDataBlockAll({})
        };

        if (!_.isEmpty(highlightedRowsRight)) {
            assignPlans(highlightedRowsRight, selectedPlanRight);
        } else if (!_.isEmpty(highlightedRows)) {
            assignPlans(highlightedRows, selectedPlan);
        }
    };


    useEffect(() => {
        if (planData?.length > 0) {
            setExpandedRows((prevExpanded) => {
                const expandedMap = { ...prevExpanded }; 

                planData.forEach((row) => {
                    expandedMap[row.uid] = true;
                });

                return expandedMap;
            });
        }
    }, [planData]);

    const closeDialog = () =>{
        setSelectedPlan(null)
        setSelectedPlanRight(null)
        setOpen(false)
        setMoveClickedToRight(false)
        setMoveClickedToMiddle(false)
        setHighlightedRows([]);
        setHighlightedRowsRight([]);
        setServicePlansRightLocal([...serviceLinePlansRight])
        setServicePlansLocal([...serviceLinePlans])
    }

    const truncateWords = (text: string, max = 30) => {
        if (!text) return "";
        if (text.length <= max) return text;

        return text.slice(0, max).trim() + "…";
        };



    const LoadIndicator = ({ selectedBox }) => {
        const label = selectedBox === "green" ? "Source" : "Destination" ;
        const isGreen = selectedBox === 'green';

        return (
            <Box className="load-indicator-container">
                <Typography className="load-indicator-title">
                    Will Load to :
                </Typography>

                <Box className={`load-indicator-pill ${isGreen ? "green" : "blue"}`}>
                    {label}
                </Box>
            </Box>
        );
    };

    const handleClose = () => {
        setOpen(false);
        clearData();
        callStarlinkTemplateAPI();
    };

    const handleVerify = () => {
        setConfirmDialog(true);
    };

    return (
        <>
     <AddEditInterfaceModal
  open={open}
  onClose={handleClose}
  onSave={handleVerify}
  title="Bulk Service Line Plan Assignment"
  saveText="Confirm"
  cancelText="Cancel"
  disableSave={_.isEmpty(highlightedRowsRight)}
  maxWidth="1420px"
  width="1420px"
  layout={[
    {
      columns: [
        {
          gridSize: 12,
          component: (
            <div >
                 <Grid container gap={2}>
                 <div className="">
         {screenLoader?.loading ? <Grid
                        container
                    >
                        <Grid item xs={12} textAlign="center">
                            <Typography variant="body1" fontWeight={500}>
                                {screenLoader?.message1}
                            </Typography>
                            <Typography variant="body2" color="textSecondary">
                                 {screenLoader?.message2}
                            </Typography>
                        </Grid>
                    </Grid> :
                        <Grid container gap={2} paddingTop={2} >
                             <Grid container xs={4} style={{background:"#EAEAEA", padding:"20px", borderRadius:"5px"}}>
                        <Grid item  xs={12} className="middleTable">
                            
                            <div className="strPlans-pb10hierarchys strPlan-tableHierarchy-Height" >
                                <Grid container className="strPlans-senderGridTop">
                                <Grid item >
                                    <Typography className="strPlan-selectPool-title3">
                                        {/* <img className="icon-cursor strPlans-pd-r-10" src={planHierarchyImg} />   */}
                                          Plan Hierarchy
                                    </Typography>
                                </Grid>
                            </Grid>
                            <LoadIndicator selectedBox={selectedBox === "middle" ? "green" : "blue"} />
                               
                                <TableContainer component={Paper} className="starlink--table_container strMap-table plan-hierarchy-height" >
                                    <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell>
                                                    <span className="font-wt-900">Plan</span>
                                                </TableCell>

                                                <TableCell>
                                                    <span className="font-wt-900">Org</span>
                                                </TableCell>

                                                <TableCell>
                                                    <span className="font-wt-900">Lines</span>
                                                </TableCell>

                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {planData?.length > 0 ? (
                                                planData?.map((row) => renderRow(row))
                                            ) : (
                                                <TableRow>
                                                    <TableCell colSpan={4} align="center">
                                                        No Plans available.
                                                    </TableCell>
                                                </TableRow>
                                            )}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                        </Grid>
                        </Grid>

                        <Grid container xs={7.5} style={{background:"#EAEAEA", padding:"0px 20px 10px 20px", borderRadius:"5px"}}>
                        <Grid item xs={5.5} className="middleTable" >
                            
                            <div 
                            className={`strPlans-pb10hierarchy strPlan-tableHierarchy-Height starlinkPlans-border-middle  ${selectedBox === MIDDLE ? "selectedMiddle" : ""}`} >
                               <div className="strPlan-selectPool-header">
                                    <span className="strPlan-selectPool-title">SOURCE</span>
                                    <Button
                                        onClick={() => { setSelectedBox(MIDDLE) }}
                                        className={selectedBox === "middle" ? "str-plans-btn-active" : "str-plans-btn-setactive"}
                                        variant="contained"
                                    >
                                        {selectedBox === "middle" ? "Active" : "Set Active"}
                                    </Button>
                                </div>
                                {
                                    selectedPlan ?
                                        <>
                                            <Grid
                                                container
                                                alignItems="center"
                                                justifyContent="space-between"
                                                className="strPlans-senderGridTop"
                                            >
                                                <Box className="starlink-plan-hierarchy-box">
                                                    <Typography className="starlink-plan-hierarchy-label">
                                                        {selectedPlan?.label || ""}
                                                    </Typography>
                                                </Box>
                                            </Grid>
                                            <Grid container spacing={1} className="configTable">
                                                
                                                <Grid item xs={12} className="usage-search-border-color">
                                                    <Box className="strPlans-searchbarBox">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            placeholder="Filter Search"
                                                            autoComplete="off"
                                                            size="small"
                                                            value={searchValue}
                                                            onChange={(e) => setSearchValue(e.target.value)}
                                                            onKeyDown={(event) => { setSearchValue(searchValue) }}
                                                            InputLabelProps={{ className: "serachLabel1" }}
                                                            InputProps={{
                                                                className: "strPlans-searchbarInputs",
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        {!searchValue && <SearchIcon
                                                                            className="searchbarIconsPosition" onClick={() => { setSearchValue(searchValue) }}
                                                                        />}
                                                                        {searchValue && <CloseIcon
                                                                            className="searchbarIconsPosition"
                                                                            onClick={() => { setSearchValue("") }}
                                                                        />}
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                            <div className="service-lines-container">
                                                    <div className="service-lines-card">
                                                        <div className={"highlight"}>{highlightedRows?.length || 0} / {servicePlansLocal?.length || 0}</div>
                                                        <div className="label"> Service Lines</div>
                                                    </div>
                                                    <div className="service-lines-card">
                                                        <div className="highlight" onClick={() => { setHighlightedRows([...servicePlansLocal]) }}>Select All</div>
                                                        <div className="highlight" onClick={() => { setHighlightedRows([]) }}>Clear </div>
                                                    </div>
                                                </div>
                                            <TableContainer component={Paper} className="starlink--table_container strMap-table strPlan-tableHeight" >
                                                <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell>
                                                                <span className="font-wt-900">Service Line</span>
                                                                <Tooltip title="SL Name / SL Number">
                                                                <Switch size="small"
                                                                    checked={switchServiceLineToggle}
                                                                    onChange={(e) => {   setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                />
                                                                </Tooltip>
                                                            </TableCell>

                                                            <TableCell>
                                                                <span className="font-wt-900">Organization</span>
                                                            </TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="strPlan-sl-table">
                                                        {servicePlansLocal?.length > 0 ? (
                                                            servicePlansLocal?.map((row: any) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    onMouseEnter={() => { setHoveredSL(row.id); }}
                                                                    onMouseLeave={() => setHoveredSL(null)} 
                                                                    onClick={() => {
                                                                        handleHighlightedRowClick(row)
                                                                        // setHighlightedRowsRight([])
                                                                    }}>
                                                                    <TableCell
                                                                     style={{
                                                                        borderTop: getBorderStyles(row),
                                                                        borderLeft: getBorderStyles(row),
                                                                        borderBottom: getBorderStyles(row) }}
                                                                        className={`strPlans-table-cell ${isHighlighted(row.id) ? 'highlighted' : ''}`}>
                                                                        {switchServiceLineToggle ? row?.id : row.service_lines}
                                                                    </TableCell>
                                                                    <TableCell
                                                                     style={{
                                                                        borderTop: getBorderStyles(row),
                                                                        borderRight: getBorderStyles(row),
                                                                        borderBottom: getBorderStyles(row) }}
                                                                        className={`strPlans-table-cell ${isHighlighted(row.id) ? 'highlighted' : ''}`}>
                                                                        {row.organization_name}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center">
                                                                    No service lines available.
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                                </> : <div className="strPlan-selectPool-container">
                                                    <div className="strPlan-selectPool-body">
                                                        <div className="strPlan-selectPool-middle">
                                                            Select a Plan from the Plan Hierarchy with the Service Line(s) to transfer
                                                        </div>
                                                    </div>
                                                </div>

                                }
                            </div>
                        </Grid>

                        <Grid item xs={1} className="strPlans-arrowBtn-grid">
                            <div className="strPlans-arrowBtn-div">
                                
                             <IconButton size="small" className="strPlan-arrowBtn"
                                    disabled={selectedPlan === null || selectedPlanRight === null || highlightedRowsRight.length === 0 || (selectedPlan === selectedPlanRight) || _.isEmpty(highlightedRowsRightTransfer)}
                                    onClick={() => {
                                        setMoveClickedToMiddle(!moveClickedToMiddle)
                                        setServicePlansLocal((prev) => [
                                            ...highlightedRowsRightTransfer.filter(
                                                (row) => !prev.some((item) => item.id === row.id)
                                            ),
                                            ...prev,
                                        ]);
                                        setServicePlansRightLocal(servicePlansRightLocal?.filter(
                                            item => !highlightedRowsRightTransfer.some(selected => selected.id === item.id)
                                        ))
                                        setHighlightedRowsRightTransfer([])
                                            setHighlightedRowsRight(
                                                highlightedRowsRight?.filter(
                                                    row => !highlightedRowsRightTransfer?.some(tr => tr?.id === row?.id)
                                                )
                                            );

                                    }}>
                                    <NavigateBeforeIcon />
                                </IconButton> 
                                
                                <IconButton size="small" className="strPlan-arrowBtn"
                                    disabled={selectedPlan === null || selectedPlanRight === null || highlightedRows.length === 0 || (selectedPlan === selectedPlanRight)}
                                    onClick={() => {
                                         setServicePlansLocal(servicePlansLocal.filter(
                                            (plan) => !highlightedRows.some((highlighted) => highlighted.id === plan.id)
                                        ))
                                        setHighlightedRowsRight([...highlightedRows, ...highlightedRowsRight])
                                        setHighlightedRows([])
                                        setMoveClickedToRight(true)
                                        setServicePlansRightLocal((prev) => [
                                            ...highlightedRows.filter(
                                                (row) => !prev.some((item) => item.id === row.id)
                                            ),
                                            ...prev,
                                        ]);
                                    }}>
                                    <KeyboardArrowRightIcon />
                                </IconButton>
                            </div>

                        </Grid>

                        <Grid item xs={5.5} className="middleTable">
                            
                            <div  className={`strPlans-pb10hierarchy strPlan-tableHierarchy-Height strPlans-pb10 starlinkPlans-border-left ${selectedBox === "right" ? "selectedRight" : ""}`}
                               >
                                 <div className="strPlan-selectPool-header">
                                                        <span className="strPlan-selectPool-title2">DESTINATION</span>
                                                        <Button
                                                            onClick={() => { setSelectedBox("right") }}
                                                            className={selectedBox === "right" ?  "str-plans-btn-active" : "str-plans-btn-setactive"}
                                                            variant="contained"
                                                        >
                                                            {selectedBox === "right" ? "Active" : "Set Active"}
                                                        </Button>
                                                    </div>
                                {
                                    selectedPlanRight ?
                                        <>
                                                    <Grid
                                                        container
                                                        alignItems="center"
                                                        justifyContent="space-between"
                                                        className="strPlans-senderGridTop"
                                                    >
                                                        <Box className="starlink-plan-hierarchy-box">
                                                            <Typography className="starlink-plan-hierarchy-label-blue">
                                                                  {truncateWords(selectedPlanRight?.label, 30)}
                                                            </Typography>
                                                        </Box>
                                                    </Grid>
                                            <Grid container spacing={1} className="configTable">

                                                <Grid item xs={12} className="usage-search-border-color">
                                                    <Box className="strPlans-searchbarBox">
                                                        <TextField
                                                            id="outlined-basic"
                                                            variant="outlined"
                                                            placeholder="Filter Search"
                                                            autoComplete="off"
                                                            size="small"
                                                            value={searchValueRight}
                                                            onChange={(e) => setSearchValueRight(e.target.value)}
                                                            onKeyDown={(event) => { setSearchValueRight(searchValueRight) }}
                                                            InputLabelProps={{ className: "serachLabel1" }}
                                                            InputProps={{
                                                                className: "strPlans-searchbarInputs",
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        {!searchValueRight && <SearchIcon
                                                                            className="searchbarIconsPosition" onClick={() => { setSearchValueRight(searchValueRight) }}
                                                                        />}
                                                                        {searchValueRight && <CloseIcon
                                                                            className="searchbarIconsPosition"
                                                                            onClick={() => { setSearchValueRight("") }}
                                                                        />}
                                                                    </InputAdornment>
                                                                ),
                                                            }}
                                                        />
                                                    </Box>
                                                </Grid>
                                            </Grid>
                                                <div className="service-lines-container">
                                                    <div className="service-lines-card">
                                                        <div className={"highlight"}>{highlightedRowsRight?.length || 0} / {servicePlansRightLocal?.length || 0}</div>
                                                        <div className="label"> Service Lines</div>
                                                    </div>
                                                     <div className="service-lines-card">
                                                        <div className="highlight" onClick={() => { handleReset() }}>Reset</div>
                                                    </div>
                                                </div>
                                            <TableContainer component={Paper} className="starlink--table_container strMap-table strPlan-tableHeight" >
                                               
                                                <Table stickyHeader size="small" aria-label="plan-hierarchy-table">
                                                    <TableHead>
                                                        <TableRow>
                                                        <TableCell>
                                                                <span className="font-wt-900">Service Line</span>
                                                                <Tooltip title="SL Name / SL Number">
                                                                <Switch size="small"
                                                                    checked={switchServiceLineToggle}
                                                                    onChange={(e) => {   setSwitchServiceLineToggle(!switchServiceLineToggle) }}
                                                                    inputProps={{ 'aria-label': 'controlled' }}
                                                                />
                                                                </Tooltip>
                                                            </TableCell>

                                                            <TableCell>
                                                                <span className="font-wt-900">Organization</span>
                                                            </TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody className="strPlan-sl-table">
                                                        {servicePlansRightLocal?.length > 0 ? (
                                                            servicePlansRightLocal?.map((row: any) => (
                                                                <TableRow
                                                                    key={row.id}
                                                                    onClick={() => {
                                                                        if(isHighlight(row.id)){
                                                                        handleHighlightedRowsClick(row)
                                                                        // setHighlightedRows([]) 
                                                                    }
                                                                    }}>
                                                                    <TableCell
                                                                          className={`strPlans-table-cell ${isHighlight(row?.id) ? 'highlighted-purpule' : ''} ${isHighlightTransfer(row?.id) ? 'transfer-left-border' : ''}`}>
                                                                          {switchServiceLineToggle ? row?.id : row.service_lines}
                                                                    </TableCell>
                                                                    <TableCell
                                                                       className={`strPlans-table-cell ${isHighlight(row?.id) ? 'highlighted-purpule' : ''} ${isHighlightTransfer(row?.id) ? 'transfer-right-border' : ''}`}>
                                                                        {row.organization_name}
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))
                                                        ) : (
                                                            <TableRow>
                                                                <TableCell colSpan={4} align="center">
                                                                    No service lines available.
                                                                </TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </> : <div className="strPlan-selectPool-container">
                                                    <div className="strPlan-selectPool-body">
                                                        <div className="strPlan-selectPool-middle">
                                                            Select a Plan from the Plan Hierarchy with the Service Line(s) to transfer
                                                        </div>
                                                    </div>
                                                </div>
                                }
                            </div>

                        </Grid> 
                        </Grid>
                         
                       
                         
                    </Grid> }
        </div>
                </Grid>
            </div>
          )
        }
      ]
    }
  ]}
/>


            <CommonModal
                open={confirmDialog}
                onClose={() => {setConfirmDialog(false)}}
                onCancelSave={() => {setConfirmDialog(false)}}
                onSave={() => handleAssignPlanToRight()}
                title="Sending Service Lines"
                saveText="Assign"
                cancelText="Back"
                showOnlineOffline={false}
                showSyncStatus={false}
                disableSave={
                    selectedPlanRight?.icon === "starlinkPlanIcon" &&
                    Object.keys(dataBlockAll || {}).every(key => dataBlockAll[key] === 0)
                }
                maxWidth="600px"
            >
                 <div style={{ padding: "16px" }}>
                {moveClickedToRight ? (
                    <>
                        <div className="strPlans-pair">
                            <div className="row">
                                <div className="label">From</div>
                                <div className="value value-green">{selectedPlan?.label}</div>
                            </div>

                            <div className="row">
                                <div className="label">To</div>
                                <div className="value value-blue">{selectedPlanRight?.label}</div>
                            </div>
                        </div>

                          {selectedPlanRight?.icon === "starlinkPlanIcon" && (
                            <>
                                {selectedPlan?.price > selectedPlanRight?.price && (
                                    <Typography className="strPlans-text">
                                        Note: This plan change will take effect from next billing cycle.
                                    </Typography>
                                )}

                                <div className="local-priority-plan-card data-blocks-add-width">
                                    <div className="local-priority-plan-row">
                                        <span className="local-priority-plan-data-label2">Data Block</span>
                                        <span className="local-priority-plan-data-label2">Count</span>
                                    </div>

                                    {selectedPlanRight?.data_block_product_details
                                        ?.filter(planRow => planRow.product_type !== "topUpProduct")
                                        ?.map((planRow, index) => {
                                            const key = planRow.product_id;
                                            return (
                                                <div key={index} className="local-priority-plan-row">
                                                    <span className="local-priority-plan-data-label">
                                                        {planRow.data_amount + " " + planRow?.data_unit}
                                                    </span>
                                                    <DataBlockCounter
                                                        value={(dataBlockAll && dataBlockAll[key]) || 0}
                                                        onChange={(newValue) => {
                                                            setDataBlockAll(prev => ({
                                                                ...prev,
                                                                [key]: newValue,
                                                            }));
                                                        }}
                                                    />
                                                </div>
                                            );
                                        })}
                                </div>
                            </>
                        )}

                        <Box mt={2}>
                            <Typography sx={{ mb: 1 }}>
                                Selected Service Lines ({highlightedRowsRight?.length})
                            </Typography>

                            <FormControl fullWidth size="small">
                                <Select
                                    multiple
                                    value={highlightedRowsRight}
                                    renderValue={(selected) => {
                                        const labels = selected.map(s => s.service_lines);
                                        if (labels.length > 2) {
                                            return `${labels[0]}, ${labels[1]} + ${labels.length - 2}`;
                                        }
                                        return labels.join(", ");
                                    }}
                                >
                                    {highlightedRowsRight?.map((row, index) => (
                                        <MenuItem key={row.id} value={row}>
                                            <div className="strPlan-index">
                                                {index + 1}.
                                            </div>

                                            <ListItemText
                                                primary={row.service_lines}
                                            />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </>
                ) : (<></>)}</div>
            </CommonModal>

    </>  
        
    )
}

const mapStateToProps = (state) => ({
    loading: state.starlinkAdmin.subcribingServiceLine,
    authReducer: state.authReducer,
    allNonAdminPermissions: state.starlinkAdmin.allNonAdminPermissions,
    starlinkMapTelemetry: state.starlinkDashboard.starlinkMapTelemetry,
    assignCustomPlanToPool: state.starlinkPooled.assignCustomPlanToPool,
    serviceLinePlans: state.starlinkPooled.serviceLinePlans,
    serviceLinePlansRight: state.starlinkPooled.serviceLinePlansRight,
    moveServicePlan: state.starlinkPooled.moveServicePlan,
    trackServicePlanMovement:state.starlinkPooled.trackServicePlanMovement
});

export default withRouter(
    connect(mapStateToProps, {
        assignCustomPlanAPI,
        getServiceLinePerPlan,
        getServiceLinePerPlanRight,
        moveServicePlanAPI,
        trackMoveServicePlan,
        clearTrackAPI,
        clearMoveServicePlan
    })(AssignServiceLine)
);